import { jsx as e } from "@emotion/react/jsx-runtime";
import { DocumentSvg as t } from "./icons/DocumentSvg.js";
import { PhotoSvg as i } from "./icons/PhotoSvg.js";
import { DropzoneTypeEnum as n } from "../../types/components/dropzone.js";
const s = {
  [n.Document]: {
    default: /* @__PURE__ */ e(t, {})
  },
  [n.Photo]: {
    default: /* @__PURE__ */ e(i, {})
  }
}, p = (o) => o < 999 * 1024 ? (o / 1024).toFixed(2) + " Kb" : o < 999 * 1024 * 1024 ? (o / 1048576).toFixed(2) + " Mb" : o + " bytes";
export {
  p as convertHumanSize,
  s as iconBuilder
};
